<script>
export default {
  data() {
    return {
      storeStatus: false,
      createLoading: false, 
      submitData: {
        isApplyToOtherDays: false,
        days: [
          {
            active: true,
            timeRange: null,
            latestReservationTime: '',
            advanceReservationTime: 1500
          },
          {
            active: false,
            timeRange: null,
            latestReservationTime: '',
            advanceReservationTime: 1500
          },
          {
            active: true,
            timeRange: null,
            latestReservationTime: '',
            advanceReservationTime: 1500
          },
          {
            active: false,
            timeRange: null,
            latestReservationTime: '',
            advanceReservationTime: 1500
          },
          {
            active: false,
            timeRange: null,
            latestReservationTime: '',
            advanceReservationTime: 1500
          },
          {
            active: false,
            timeRange: null,
            latestReservationTime: '',
            advanceReservationTime: 1500
          },
          {
            active: false,
            timeRange: null,
            latestReservationTime: '',
            advanceReservationTime: 1500
          },
        ],
      },
    };
  },
  methods: {
    dayText(day) {
      return ['週一', '週二', '週三', '週四', '週五', '週六', '週日'][day] || ''
    },
    onClickLeave() {
      // this.$router.back()
    },
    tryToStore() {
      console.log('tryToStore')
    }
  },
}
</script>
<template>
  <div class="container">
    <el-form ref="form" :model="submitData" label-position="top">
      <div class="info-line-box">
        <h3 style="font-size:16px;">入住退房時間設定</h3>
        <el-form-item label="" prop="isEnabled" class="mb-0 ml-4">
          <el-checkbox v-model="submitData.isApplyToOtherDays" label="同營業時間"></el-checkbox>
        </el-form-item>
      </div>
      <ul>
        <li v-for="(day, index) in submitData.days" :key="index" class="row">
          <div>
            <el-form-item label="" prop="isEnabled" class="mb-0">
              <el-switch v-model="day.active" :active-text="dayText(index)" :active-value="true"
                :inactive-value="false"></el-switch>
            </el-form-item>
          </div>
          <div>
            <div class="flex col">
              <span class="form-block-title">
                <span>入住退房時間設定</span>
              </span>
              <el-form-item prop="isEnabled" class="mt-1 mb-0">
                <el-time-picker
                  v-model="day.timeRange"
                  is-range
                  range-separator="至"
                  start-placeholder="開始時間"
                  end-placeholder="結束時間">
                </el-time-picker>
              </el-form-item>
            </div>
            <el-form-item prop="isEnabled" class="mt-0">
              <el-checkbox v-if="index === 0" :value="day.isApplyToOtherDays" label="將週一入住退房時間套用至其他日"></el-checkbox>
            </el-form-item>
          </div>
          <div>
            <div class="flex col ml-4">
              <span class="form-block-title">
                <span class="isStyleRequired">最晚接受預約時間</span>
              </span>
              <el-form-item prop="isEnabled" class="mt-1">

                <el-time-picker
                  v-model="day.latestReservationTime"
                  placeholder="選擇時段">
                </el-time-picker>
              </el-form-item>
              </el-form-item>
            </div>
            <div class="flex col ml-4">
              <span class="form-block-title">
                <span class="isStyleRequired">提前預約時間</span>
              </span>
              <el-form-item prop="isEnabled" class="mt-1">
                <el-input v-model="day.advanceReservationTime" placeholder="選擇時段" />
              </el-form-item>
            </div>
            <span class="ml-4">分鐘</span>
          </div>
        </li>
      </ul>
    </el-form>
    <div :class="$style.footer">
      <el-button class="is-round" @click="onClickLeave">取消編輯</el-button>
      <el-button :loading="storeStatus || createLoading" class="is-round" type="primary" @click="tryToStore">儲存編輯</el-button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>

<style lang="scss" scoped>
.flex {
  display: flex;

  &.col {
    flex-direction: column;
  }
}

.container {
  padding: 18px 20px 40px;
  background-color: #fff;

  li {
    display: flex;

    > :nth-child(1) {
      flex: 0 0 auto;
      margin-top: 29px
    }

    > :nth-child(2) {
      position: relative;
      margin-left: 48px;

      &:before {
        content: '';
        position: absolute;
        display: block;
        width: 1px;
        height: 30px;
        top: 35px;
        left: -24px;
        background: #E5E7EB;
      }

      .form-block-title {
        font: normal normal normal 14px/26px PingFang TC;
        letter-spacing: 2.1px;
        color: #121931;
      }

      .el-input__inner {
        background-color: white;
      }
    }
    > :nth-child(3) {
      flex: 0 0 auto;
      display: flex;

      .form-block-title {
        font: normal normal normal 14px/26px PingFang TC;
        letter-spacing: 2.1px;
        color: #121931;
      }

      > span {
        margin-top: 40px;
      }
    }

    + li {
      border-top: 1px solid #E5E7EB;
      padding-top: 20px;
    }
  }
}
</style>